export default __webpack_public_path__ + "ef0ff6fc89a494612438bbf3bfb4b718.svg";